import React, { Component, startTransition } from 'react'
import HydrationSplitter from '../HydrationSplitter.jsx'
import DeprecatedSection from '../atoms/Section/Section'
import Section from '@/components/Section'
import NavMarker from '../organisms/StickyBar/NavMarkers.jsx'
import LongDescription from '../molecules/LongDescription/LongDescription'
import ProfileIntro from '../organisms/ProfileIntro/ProfileIntro'
import ContactBar from '../../components/organisms/StickyBar/ContactBar'
import CenterReviews from '../organisms/CenterReviews/CenterReviews.jsx'
import TaxonomySections from '../organisms/TaxonomySections/TaxonomySections'
import { algoliaCenterSearch } from '@/lib/algoliaCenterSearch'
import VerifiedInfo from '../organisms/VerifiedInfo/VerifiedInfo'
import TeamMembers from '../organisms/TeamMembers/TeamMembers'
import SimilarCentersCards from '../SimilarCentersCards/SimilarCentersCards'
import InsuranceInformation from '../organisms/InsuranceInformation/InsuranceInformation'
import StickyBar from '../organisms/StickyBar/StickyBar'
import { InView } from 'react-intersection-observer'
import Container from '@/components/Container'
import Map from '@/components/Map'
import { isSSR } from '../../utils/ssrUtils'
import ContentPicture from '../molecules/ContentPicture/ContentPicture'
import LuxuryContentPicture from '../molecules/ContentPicture/Luxury/LuxuryContentPicture'
import computeIsLuxury from '@/domain/useCases/center/computeIsLuxury'
import { shouldDisplayVerificationOfBenefits } from '../../domain/useCases/contactBarDisplay.js'
import {
  computeAllReviewsCount,
  computeAllReviewsWeightedAverage
} from '../../domain/centerReviews/centerReviews.js'
import VirtualTour, {
  VIRTUAL_TOUR_ID
} from '../organisms/VirtualTour/VirtualTour'
import { getPrimaryFocusFilter } from '@/domain/primaryFocus/useCases/getPrimaryFocusFilter'
import { shouldDisplayInsuranceBlock } from '@/domain/useCases/insurance/shouldDisplayInsuranceBlock'
import { getNearByCarouselTitle } from '@/domain/primaryFocus/useCases/getNearByCarouselTitle'
import appendUtmSourceAndMediumToUrl from '../../domain/appendUtmSourceAndMediumToUrl'
import { isNonEmptyArray } from '../../utils/checks'
import { getPhoneNumbers, getWebsite, isLuxCenter } from '../../domain/center'
import CenterCarousel from '../molecules/CenterCarousel/CenterCarousel'
import { ZoneIds } from '../../domain/zoneIds'
import { Page } from '../../types/models/PageType.model'
const SNPONSOR_CENTER_COUNT_TO_SHOW = 5
const FREE_CENTER_COUNT_TO_SHOW = 5

const NEARBY_AROUND_RADIUS_IN_METERS = 804672
export default class Standard extends Component {
  constructor(props) {
    super(props)

    const navLinks =
      props.data?.accepted_insurance?.length > 0 &&
      props.data.insurance_description &&
      props.data.verify_insurance_link
        ? [
            {
              label: 'About',
              sectionId: 'profile-about'
            },
            {
              label: 'Insurance',
              sectionId: 'profile-insurance'
            },
            {
              label: 'Treatment',
              sectionId:
                // FIXME: this should probably be this.props
                this.state?.data?.text_picture?.length > 0
                  ? 'profile-treatment'
                  : 'profile-treatments'
            },
            {
              label: 'Amenities',
              sectionId: 'profile-amenities'
            }
          ]
        : [
            {
              label: 'About',
              sectionId: 'profile-about'
            },
            {
              label: 'Treatment',
              sectionId:
                // FIXME: this should probably be this.props
                this.state?.data?.text_picture?.length > 0
                  ? 'profile-treatment'
                  : 'profile-treatments'
            },
            {
              label: 'Amenities',
              sectionId: 'profile-amenities'
            }
          ]

    navLinks.push({
      label: 'Reviews',
      sectionId: 'profile-reviews'
    })
    if (props?.data?.team_members > 0) {
      navLinks.push({
        label: 'Staff',
        sectionId: 'profile-staff'
      })
    }
    navLinks.push({
      label: 'FAQs',
      sectionId: 'profile-faqs'
    })

    this.state = {
      navLinks: navLinks,
      similarLoading: true,
      isContactBarVisible: false,
      isLoading: true,
      stuck: false,
      sponsor_placements: [],
      mergedSimilarAndSponsored: [],
      standard_placements: false,
      similar: [],
      outofView: false,
      data: {
        ...props.data,
        website: appendUtmSourceAndMediumToUrl(getWebsite(props.data))
      }
    }

    // the below code pertains to Google Tag Manager and may have no context outside of this file; DO NOT DELETE.
    if (!isSSR()) {
      window.dataLayer.push({ ecommerce: null })
      window.dataLayer.push({
        event: 'view_item',
        ecommerce: {
          items: [
            {
              item_name: this.state.data.title,
              item_id: this.state.data.slug,
              item_variant: 'Standard'
            }
          ]
        }
      })
    }
  }

  componentDidMount() {
    if (this.props.data._geoloc) {
      const primaryFocusFilter = getPrimaryFocusFilter(
        this.props.data.primaryFocus
      )

      Promise.all([
        algoliaCenterSearch({
          query: '',
          filters: `(sponsor_tier = 3 OR sponsor_tier = 2 OR sponsor_tier = 1) AND site:lux AND ${primaryFocusFilter}`,
          aroundLatLng: `${this.props.data._geoloc.lat}, ${this.props.data._geoloc.lng}`,
          aroundRadius: NEARBY_AROUND_RADIUS_IN_METERS,
          hitsPerPage: SNPONSOR_CENTER_COUNT_TO_SHOW
        }),
        algoliaCenterSearch({
          query: '',
          filters: `claimed:true AND site:lux AND sponsor_tier != 1 AND sponsor_tier != 2 AND sponsor_tier != 3 AND ${primaryFocusFilter}`,
          aroundLatLng: `${this.props.data._geoloc.lat}, ${this.props.data._geoloc.lng}`,
          aroundRadius: NEARBY_AROUND_RADIUS_IN_METERS,
          hitsPerPage: FREE_CENTER_COUNT_TO_SHOW
        })
      ])
        .then(([sponsorPlacements, similarCenters]) => {
          startTransition(() => {
            this.setState({
              sponsor_placements: sponsorPlacements.hits,
              similar: similarCenters.hits,
              mergedSimilarAndSponsored: similarCenters.hits
                .reduce((acc, center, index) => {
                  acc.push(center, sponsorPlacements.hits[index])
                  return acc
                }, [])
                .filter(Boolean)
                .filter((center) => center.title !== this.state.data.title),
              similarLoading: false
            })
          })
        })
        .catch((e) => console.log(e))
    }

    window.addEventListener(
      'scroll',
      (this.handleScroll = () => {
        let scroll = window.scrollY
        const newIsContactBarVisible = scroll > 1500
        if (newIsContactBarVisible !== this.state.isContactBarVisible) {
          // This state update is wrapped with startTransition() because any
          // state update that might re-render <HydrationSplitter> should be.
          // Otherwise, we’ll get the “This Suspense boundary received an
          // update before it finished hydrating” error and worse performance.
          // More details: https://github.com/RehabPath/luxuryrehab.in/pull/2921
          startTransition(() => {
            this.setState({ isContactBarVisible: newIsContactBarVisible })
          })
        }
      })
    )
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  }

  render() {
    const nativeReviews = (
      this.props.reviews?.edges ||
      this.props.reviews ||
      []
    ).map((item) => ({
      ...item.node
    }))
    const allReviewsCount = computeAllReviewsCount(this.props.data)
    const allReviewsWeightedAverage = computeAllReviewsWeightedAverage(
      this.props.data
    )

    return (
      <div>
        <InView
          as="div"
          onChange={(inView, entry) => {
            if (inView === !this.state.outofView) {
              return
            } else {
              // This state update is wrapped with startTransition() because any
              // state update that might re-render <HydrationSplitter> should be.
              // Otherwise, we’ll get the “This Suspense boundary received an
              // update before it finished hydrating” error and worse performance.
              // More details: https://github.com/RehabPath/luxuryrehab.in/pull/2921
              startTransition(() => {
                this.setState({ ...this.state, outofView: !inView })
              })
            }
          }}
        >
          <div />
        </InView>
        {this.state.outofView && (
          <StickyBar
            data={this.props.data}
            queryID={this.props.queryID}
            showEmailNavbar={false}
            navigationLinks={this.state.navLinks}
            reviewsCount={allReviewsCount}
            allReviewsWeightedAverage={allReviewsWeightedAverage}
          />
        )}

        <ProfileIntro
          breadcrumbs={this.props.breadcrumbs}
          queryID={this.props.queryID}
          allReviewsCount={allReviewsCount}
          allReviewsWeightedAverage={allReviewsWeightedAverage}
          data={this.state.data}
          virtualTourElementId={VIRTUAL_TOUR_ID}
          pageType={Page.CENTER_PROFILE}
          centerId={this.props.data.id}
        />

        <CenterCarousel
          isLoading={false}
          sectionHeading={getNearByCarouselTitle(this.props.data.primaryFocus)}
          centers={this.state.mergedSimilarAndSponsored}
          containerId="nearBy"
          zoneId={ZoneIds.Nearby}
        />

        {this.state.data.long_description &&
          this.state.data.long_description.length > 3 && (
            <DeprecatedSection id="target">
              <NavMarker
                standard
                id="profile-about"
              >
                <LongDescription
                  centerTitle={this.state.data.title}
                  video_embed={this.state.data.video_embed}
                  dangerouslySetInnerHTML={{
                    __html: this.state.data.long_description
                  }}
                />
              </NavMarker>
            </DeprecatedSection>
          )}

        <HydrationSplitter>
          <NavMarker
            standard
            id="profile-insurance"
          >
            <InsuranceInformation
              center={this.state.data}
              insurance_description={this.state.data.insurance_description}
              verify_insurance_link={this.state.data.verify_insurance_link}
              shouldShowVerifyBenefits={shouldDisplayVerificationOfBenefits(
                this.state?.data?.benefitsProvider
              )}
              shouldDisplayInsuranceBlock={shouldDisplayInsuranceBlock({
                acceptedInsurance: this.state?.data?._insurance_info,
                insuranceDescription: this.state?.data?.insurance_description,
                verifyInsuranceLink: this.state?.data?.verify_insurance_link,
                phone: this.state?.data?.phone
              })}
              benefitsKey={this.state?.data.benefitsKey}
              benefitsProvider={this.state?.data.benefitsProvider}
              centerTitle={this.state?.data?.title}
              phoneNumber={this.state?.data?.phone}
            />
          </NavMarker>
        </HydrationSplitter>

        {isLuxCenter(this.props.data) && (
          <SimilarCentersCards algoliaObjectId={this.props.data.slug} />
        )}

        {computeIsLuxury(this.state.data) && (
          <HydrationSplitter>
            <LuxuryContentPicture />
          </HydrationSplitter>
        )}

        {this.state.data.text_picture !== null && (
          <HydrationSplitter>
            {this.state?.data?.text_picture?.map((item, i) => {
              if (i % 2 === 0) {
                return (
                  <div
                    className="mb-6 md:mb-12"
                    key={item.title}
                  >
                    <Section>
                      <Container>
                        <ContentPicture
                          title={item?.title}
                          content={item?.content}
                          link={
                            item.link
                              ? { link: item.link, text: 'Learn More' }
                              : undefined
                          }
                          image={`https://res.cloudinary.com/rehabpath/image/upload/${item?.image
                            ?.split('/')
                            ?.pop()}`}
                          charcoal
                        />
                      </Container>
                    </Section>
                  </div>
                )
              } else {
                return (
                  <div
                    className="mb-6 md:mb-12"
                    key={item.title}
                  >
                    <Section>
                      <Container>
                        <ContentPicture
                          gray={true}
                          reverse
                          title={item?.title}
                          content={item?.content}
                          link={
                            item.link
                              ? { link: item.link, text: 'Learn More' }
                              : undefined
                          }
                          image={`https://res.cloudinary.com/rehabpath/image/upload/${item?.image
                            ?.split('/')
                            ?.pop()}`}
                        />
                      </Container>
                    </Section>
                  </div>
                )
              }
            })}
          </HydrationSplitter>
        )}
        {this.state.data.certifications && (
          <HydrationSplitter>
            <VerifiedInfo
              title={this.state.data.title}
              certs={this.state.data.certifications}
              description={this.props.data.verified_description}
            />
          </HydrationSplitter>
        )}

        {this.state.data && (
          <HydrationSplitter>
            <TaxonomySections
              standard
              data={{
                _treatment_method: this.state.data?._treatment_method || [],
                overviewAddress: this.state.data.address,
                founded: this.state.data.founded_date,
                occupancy: this.state.data.occupancy,
                treatment_therapies: this.state.data.treatment_therapies,
                onsite_activities: this.state.data.onsite_activities,
                off_site_activities: this.state.data.off_site_activities,
                languages: this.state.data.languages,
                price_length: this.state.data.price_length,
                _therapies: this.state.data._treatment_therapies,
                therapies: this.state.data.treatment_therapies,
                aftercare: this.state.data.aftercare,
                onsite_amenities: this.state.data.onsite_amenities,
                off_site_amenities: this.state.data.off_amenities,
                personal_amenities: this.state.data.personal_amenities,
                price_label: this.state.data.price_label,
                length_label: this.state.data.length_label,
                _special_considerations:
                  this.state.data._special_considerations,
                arranged_aftercare: this.state.data.arranged_aftercare,
                included_aftercare: this.state.data.included_aftercare,
                accredidation: this.state.data.accredidation,
                _onsite_activities: this.state.data._onsite_activities,
                amenities: [
                  ...(this.state.data.onsite_amenities || []),
                  ...(this.state.data.off_amenities || []),
                  ...(this.state.data.personal_amenities || [])
                ],
                _off_site_activities: this.state.data._off_site_activities,
                _amenities: this.state.data._amenities,
                _what_we_treat: this.state.data._what_we_treat,
                special_considerations: this.state.data.special_considerations,
                activities: [
                  ...(this.state.data.onsite_activities || []),
                  ...(this.state.data.off_site_activities || [])
                ],
                who_we_treat: this.state.data._who_we_treat,
                what_we_treat: this.state.data.what_we_treat,
                _treatment_services: this.state.data._treatment_services,
                new_specializations: this.props.data._new_specializations,
                locations: this.state.data.locations,
                is_standard: true,
                taxonomyList: this.props.taxonomyList,
                primaryFocus: this.state.data.primaryFocus,
                acceptsInsurance:
                  this.state.data?.accepted_insurance?.length > 0
              }}
            />
          </HydrationSplitter>
        )}

        {isNonEmptyArray(this.state.data.team_members) && (
          <NavMarker
            standard
            id="profile-staff"
          >
            <Section>
              <div className="border-t-1 mt-6 h-6 border-gray-200 md:mt-12 md:h-12" />
              <Container>
                <TeamMembers data={this.state.data.team_members} />
              </Container>
            </Section>
          </NavMarker>
        )}

        <NavMarker
          id="profile-reviews"
          spacing="0px"
        >
          <DeprecatedSection className="sub-nav-item"></DeprecatedSection>
        </NavMarker>

        <HydrationSplitter>
          <DeprecatedSection fluid>
            <DeprecatedSection fluid>
              <CenterReviews
                center={this.props.data}
                nativeReviews={nativeReviews}
              />
            </DeprecatedSection>
          </DeprecatedSection>
        </HydrationSplitter>

        {this.props.data?.virtual_tour_embed && (
          <HydrationSplitter>
            {this.props.data?.virtual_tour_embed && (
              <VirtualTour
                embedSrc={this.props.data.virtual_tour_embed}
                containerClass="relative mx-auto mb-6 w-full max-w-[1600px]"
                iframeClass="w-full h-[453px] md:h-[935px]"
              />
            )}
          </HydrationSplitter>
        )}

        <HydrationSplitter>
          <Section>
            <Container size="lg">
              <Map
                query={this.state.data.location_query}
                locationLabel={
                  this.state.data.address || this.state.data.location_label
                }
                title={this.state.data.title}
              />
            </Container>
          </Section>
        </HydrationSplitter>

        {isNonEmptyArray(getPhoneNumbers(this.state.data)) && (
          <HydrationSplitter>
            {this.state.isContactBarVisible && (
              <ContactBar
                data={this.state.data}
                stuck={this.state.stuck}
                email={this.state.data.email}
                phone={getPhoneNumbers(this.state.data)[0]}
                title={this.state.data.title}
                claimedEmail={this.state.data.claimed_email}
                breadcrumbs={this.state.data.breadcrumbs}
                queryID={this.state.data.queryID}
              />
            )}
          </HydrationSplitter>
        )}
      </div>
    )
  }
}
